import React, { useLayoutEffect, PropsWithChildren } from "react";

const OneTrustCookieSettingsButton = ({ children }: PropsWithChildren) => {
	useLayoutEffect(() => {
		if (window.OneTrust == null) {
			return;
		}

		try {
			window.OneTrust.initializeCookiePolicyHtml();
		} catch {
			// Ignoring the OneTrust error, because it will
			// be recovered by OneTrust itself
		}
	});

	return (
		<>
			<a id="ot-sdk-btn" className="ot-sdk-show-settings">
				{children}
			</a>
			<style>{`
								#ot-sdk-btn.ot-sdk-show-settings, #ot-sdk-btn.optanon-show-settings {
									font-size: inherit;
									font-weight: 400;
									line-height: 1.5em;
									color: inherit;
									padding: 0;
									border: none;
									background: none;
								}
								#ot-sdk-btn.ot-sdk-show-settings:hover, #ot-sdk-btn.optanon-show-settings:hover {
									color: #2EC99B;
									background: none;
								}
								`}</style>
		</>
	);
};

export default OneTrustCookieSettingsButton;
